import Icons from 'images/icons';

export const KARTE_ICONS = {
  エンジンオイル: Icons.oil,
  オイルフィルター: Icons.filterOil,
  夏タイヤ: Icons.tireAll,
  スタッドレスタイヤ: Icons.winter,
  エアコンフィルター: Icons.filterAircon,
  ワイパー: Icons.wiper,
  バッテリー: Icons.battery,
  エアフィルター: Icons.filterAir,
  ATF: Icons.atf,
  車検: Icons.shaken,
};

/**
 * 車画像名の末尾
 */
export const CAR_IMAGE_SUFFIX = {
  エンジンオイル: 'e',
  オイルフィルター: 'e',
  バッテリー: 'b',
  ATF: 'b',
  エアコンフィルター: 'a',
  エアフィルター: 'a',
  ワイパー: 'w',
  夏タイヤ: 't',
  スタッドレスタイヤ: 't',
  車検: 's',
};

/**
 * 車画像のマッピング
 */
export const CAR_IMAGE = {
  car_a: Icons.car_a,
  car_b: Icons.car_b,
  car_e: Icons.car_e,
  car_s: Icons.car_s,
  car_t: Icons.car_t,
  car_w: Icons.car_w,
  car: Icons.car,
};
